import type { IntentTemplate } from "../types";

export const DISCOUNTS_INTENT_TEMPLATES = {
  CREATE_DISCOUNT: {
    label: "Discount",
    pendingTitle: "Review Discount Creation",
    summary: () => "A new auto-apply discount will be created.",
    fieldLabels: {
      input: "Discount Details",
    },
  },
  UPDATE_DISCOUNT: {
    label: "Discount",
    pendingTitle: "Review Discount Update",
    summary: (payload) =>
      typeof payload.discountTitle === "string" && payload.discountTitle.trim().length > 0
        ? `Discount "${payload.discountTitle}" will be updated.`
        : typeof payload.discountId === "string"
          ? "Existing discount will be updated."
          : "A discount will be updated.",
    fieldLabels: {
      discountTitle: "Discount",
      input: "Changes",
    },
  },
  DELETE_DISCOUNT: {
    label: "Discount",
    pendingTitle: "Review Discount Deletion",
    summary: (payload) =>
      typeof payload.discountTitle === "string" && payload.discountTitle.trim().length > 0
        ? `Discount "${payload.discountTitle}" will be deleted.`
        : "A discount will be deleted.",
    fieldLabels: {
      discountTitle: "Discount",
    },
  },
} satisfies Record<string, IntentTemplate>;
